import React from 'react';
import c from '../w.js';

const IconHelpOutlined = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12.4928 14.0071H10.8373V13.8778C10.8472 12.088 11.3543 11.5362 12.2343 10.9893C12.8358 10.6115 13.2982 10.1342 13.2982 9.43819C13.2982 8.65765 12.6867 8.15055 11.926 8.15055C11.225 8.15055 10.5489 8.59799 10.5042 9.53265H8.73428C8.784 7.64344 10.1959 6.67896 11.936 6.67896C13.8351 6.67896 15.1427 7.73293 15.1427 9.41333C15.1427 10.5518 14.5709 11.2976 13.6562 11.8444C12.8458 12.3416 12.5027 12.8238 12.4928 13.8778V14.0071ZM12.801 16.0156C12.7961 16.6221 12.2939 17.1094 11.7073 17.1094C11.1008 17.1094 10.6086 16.6221 10.6135 16.0156C10.6086 15.419 11.1008 14.9318 11.7073 14.9318C12.2939 14.9318 12.7961 15.419 12.801 16.0156Z"
      }
    )
  )
);

export { IconHelpOutlined };
